import { AppliedContentFilters } from './types';
import { createBehaviorSubject } from 'packages/behavior-subject';

const ContentFilters = createBehaviorSubject</* Set val to null to indicate loading */
AppliedContentFilters | null>({});

export const updateContentFilters = ContentFilters[0];
export const subscribeContentFilters = ContentFilters[1];
